export class OfferBenefits {
  id: number;
  name: string;
  pictureUrl: string;
  price: number;
  serviceFee: number;
  includesVat: boolean;
  vatPercentage: number;
  discountPercentage: number;
  isBusinessProduct: boolean;
  providerId: number;
  providerName: string;
}
